import { Users } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { SectionHeader } from "./ReportsShared";

export const CoordinatorPerformanceSection = ({ coordinator_performance }) => (
  <section data-testid="section-coordinators" id="section-coordinators">
    <SectionHeader icon={Users} title="Coordinator Performance" subtitle="Workload and task completion" />
    {coordinator_performance.length > 0 ? (
      <Card className="card-surface">
        <CardContent className="p-0">
          <table className="w-full text-sm" data-testid="coordinator-table">
            <thead>
              <tr style={{ borderBottom: "1px solid var(--t-border)" }}>
                <th className="text-left px-5 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Coordinator</th>
                <th className="text-center px-3 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Assigned</th>
                <th className="text-center px-3 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Closed</th>
                <th className="text-center px-3 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Tasks</th>
                <th className="text-center px-3 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Completion</th>
                <th className="text-center px-3 py-3 text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Overdue</th>
              </tr>
            </thead>
            <tbody>
              {coordinator_performance.map((c) => (
                <tr key={c.coordinator_id} style={{ borderBottom: "1px solid var(--t-border-light)" }} className="hover:bg-[var(--t-row-hover)]">
                  <td className="px-5 py-3 font-medium" style={{ color: "var(--t-text)" }}>{c.name}</td>
                  <td className="text-center px-3 py-3" style={{ color: "var(--t-text)" }}>{c.assigned}</td>
                  <td className="text-center px-3 py-3" style={{ color: "#059669" }}>{c.closed}</td>
                  <td className="text-center px-3 py-3" style={{ color: "var(--t-text)" }}>{c.tasks_completed}/{c.tasks_total}</td>
                  <td className="text-center px-3 py-3">
                    <span className="inline-block px-2 py-0.5 rounded text-xs font-semibold" style={{
                      background: c.completion_rate >= 80 ? "#dcfce7" : c.completion_rate >= 50 ? "#fef3c7" : "#fef2f2",
                      color: c.completion_rate >= 80 ? "#166534" : c.completion_rate >= 50 ? "#92400e" : "#991b1b",
                    }}>
                      {c.completion_rate}%
                    </span>
                  </td>
                  <td className="text-center px-3 py-3">
                    {c.tasks_overdue > 0 ? (
                      <span className="inline-block px-2 py-0.5 rounded text-xs font-semibold" style={{ background: "#fef2f2", color: "#dc2626" }}>{c.tasks_overdue}</span>
                    ) : (
                      <span style={{ color: "#059669" }}>0</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>
    ) : (
      <Card className="card-surface">
        <CardContent className="py-10 text-center text-sm" style={{ color: "var(--t-text-muted)" }}>
          No coordinators assigned yet
        </CardContent>
      </Card>
    )}
  </section>
);
